<template>
    <div :id="dialogId"
         class="modal fade"
         role="dialog"
         :aria-labelledby="`${dialogId}Title`"
         aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered dialog-small"
             role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <label :id="`${dialogId}Title`"
                           class="modal-title">
                        <i class="icon icon-delete" />
                        Delete preset
                    </label>
                </div>
                <div class="modal-body">
                    <label>Select preset to delete</label>
                    <div>
                        <select v-model="selectedPreset">
                            <option v-for="preset in presets"
                                    :key="`preset-${preset.id}`"
                                    :value="preset.id">
                                {{ preset.name }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="modal-footer left-align">
                    <div class="ms-auto">
                        <button type="button"
                                class="btn btn-color btn-outline-primary btn-sm"
                                @click="cancelLoad">
                            Go Back
                        </button>
                        <update-button button-label="Delete"
                                       :sending="sending"
                                       @click="deleteConfirm" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { defineProps, defineExpose, onMounted, computed, ref } from 'vue';
    import axios from 'axios';
    import UpdateButton from '../UpdateButton.vue';
    import { modalDialog } from '../../js/ModalDialog.js';
    import { axiosError, axiosConfig } from '../../js/AjaxUtilities.js';

    const props = defineProps({
        idNumber: { // number to make dialog unique
            type: Number,
            default: 0
        },
        type: { // type number. 0 = Recovery Goal, 1 = Relapse Prevention
            type: Number,
            default: 0
        }
    });

    defineExpose({
        show
    });

    const selectedPreset = ref(0);
    const sending = ref(false);

    function show() {
        loadPresetsAndShow();
    }

    const dialogId = computed(() => `delete-preset-dialog-${props.idNumber}`);

    const presets = ref([]);

    function cancelLoad() {
        modalDialog.closeModal(dialogId.value);
    }

    function loadPresetsAndShow() {
        let type = props.type;

        axios
            .post(`/GoalPlan/LoadPresets`, type, axiosConfig())
            .then(function (response) {
                if (response.data.success) {
                    presets.value = response.data.presets;
                    showDialog();
                } else {
                    alert(`Failed to load presets: ${response.data.message}`);
                }
            })
            .catch(function (error) {
                axiosError("Load presets", axios, error);
            });
    }

    function showDialog() {
        modalDialog.openModal(dialogId.value);
    }

    function deleteConfirm() {
        sending.value = true;

        axios
            .delete(`/GoalPlan/DeletePreset?type=${props.type}&presetId=${selectedPreset.value}`)
            .then(function (response) {
                if (!response.data.success) {
                    alert(`Failed to delete preset: ${response.data.message}`);
                }
            })
            .catch(function (error) {
                axiosError("Delete preset", axios, error);
            })
            .finally(() => {
                modalDialog.closeModal(dialogId.value);
                sending.value = false;
            })

    }


</script>
